import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

/** Warning icon shown when publishing is restricted for a platform. */
export function PublishRestrictionWarning() {
  return <WarningAmberRoundedIcon fontSize="small" color="warning" />;
}
